import { citations, sections } from '../../content/howItWorks'

// The science, with its sources. Every citation number resolves to a URL the research brief verified.
export function HowItWorks({ styleModel, styleDimensions }: { styleModel: string; styleDimensions: number }) {
  return (
    <details className="card science-card">
      <summary><h2>How this works</h2><span className="muted">the science and its sources</span></summary>
      <p className="muted">
        Style space {styleModel} ({styleDimensions} dimensions). Everything on this page is measured from your sent mail; nothing is inferred from a template.
      </p>
      {sections.map((s) => (
        <section key={s.title} className="science">
          <h3>{s.title}</h3>
          {s.body.map((p, i) => (
            <p key={i}>
              {p}{' '}
              {i === s.body.length - 1 && (
                <span className="cites">
                  {s.cites.map((n) => (
                    <a key={n} href={citations.find((c) => c.n === n)?.url} target="_blank" rel="noreferrer">
                      [{n}]
                    </a>
                  ))}
                </span>
              )}
            </p>
          ))}
        </section>
      ))}
      <h3>Sources</h3>
      <ol className="sources">
        {citations.map((c) => (
          <li key={c.n} value={c.n}>
            <a href={c.url} target="_blank" rel="noreferrer">
              {c.title}
            </a>{' '}
            <span className="muted">— {c.who}</span>
          </li>
        ))}
      </ol>
    </details>
  )
}
